module.exports = __webpack_public_path__ + "assets/img/8外部接入.61b8dd6a.jpg";